import { ContentFilters, ContentTopBar } from 'components';
import { RefundFilterForm } from 'features/transaction_list/component/refund-request-filter-form/refund-request-filter-form';
import { RefundRequestFormValues } from 'features/transaction_list/component/refund-request-filter-form/type';
import { useState } from 'react';
import { CompanyType } from 'types';

type ParticipateTopBarProps = {
  getInitialFilterValues: RefundRequestFormValues;
  handleFilter: (values: RefundRequestFormValues) => void;
};

export const RequestRefundTopBar = ({
  getInitialFilterValues,
  handleFilter,
}: ParticipateTopBarProps) => {
  useState<CompanyType>();
  const formId = 'expo-list-filters-form';
  
  return (

    <>
      <ContentTopBar
        title={'Refund Request' }

      />

      <ContentFilters formId={formId}>
        <RefundFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
